import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useLazyGetUserNoEmailQuery } from "api";
import { OBJ_COLOR } from "commons/constants";
import FileSaver from "file-saver";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

export const ExportDataNoEmail = () => {
	const [getUserNoEmail, { data: DATA }] = useLazyGetUserNoEmailQuery();
	const [isLoading, setIsLoading] = useState(false);
	const handleOnClickExportData = () => {
		setIsLoading(true);
		getUserNoEmail(undefined);
	};

	useEffect(() => {
		if (!DATA) return;

		const Heading = [{ stt: "Stt", userId: "Mã nhân viên", name: "Tên", url: "Url" }];
		const wscols = [{ wch: 6 }, { wch: 10 }, { wch: 15 }, { wch: 20 }];
		const header: any[] = [];

		const dataExport = DATA?.map((item, index) => {
			return {
				stt: index + 1,
				userId: item.userId,
				url: item.url,
				name: item.name,
			};
		});

		const ws = XLSX.utils.json_to_sheet(Heading, {
			header,
			skipHeader: true,
		});
		ws["!cols"] = wscols;

		XLSX.utils.sheet_add_json(ws, dataExport || [], {
			header,
			skipHeader: true,
			origin: -1, //ok
		});
		const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
		const data = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, "users-no-email" + fileExtension);
		setIsLoading(false);
	}, [DATA]);

	return (
		<>
			<Button loading={isLoading} onClick={handleOnClickExportData} type="primary" style={{ background: OBJ_COLOR.INFO, borderColor: OBJ_COLOR.INFO }} icon={<DownloadOutlined />}>
				Export no email
			</Button>
		</>
	);
};
